<template>
    <span class="sync-btn-container">
        <button v-if="status" @click="onButtonClick()" class="btn btn-light btn-refresh" :class="{'btn-spinner-only': isLoading || isSyncOngoing, 'disabled': isLoading || isSyncOngoing}">
            <span v-if="isLoading || isSyncOngoing"><span class="spinner anim-spin"></span></span>
            <span v-if="!isLoading && !isSyncOngoing" style="font-weight: bold;"><i class="fa fa-download"></i> {{ syncButtonText(syncType) }}</span>
        </button>
    </span>
</template>
<script>
import Sync from "../../Services/Sync";

export default {

        props: ['centre', 'company', 'syncType'],

        data: () => { return {
            isLoading: false,
            isSyncOngoing: false,
            syncScope: 'centre',
            status: status,
        }},

        mounted: function() {
            if(this.company) {
                this.syncScope = 'company';
            }

            this.refreshStatus();

            setInterval(() => this.refreshStatus(), 10000);
        },

        methods: {

            syncButtonText(syncType) {
                return syncType === 'company_bookings' ? 'Sync bookings' : 'Sync';
            },

            refreshStatus: function () {
                Sync.getManualSyncStatus(this.syncType, this.centre || '', this.company || '')
                    .then((status) => {
                        this.status = status;
                        this.isLoading = false;
                        this.isSyncOngoing = !!status.has_sync_ongoing;
                        this.$forceUpdate();
                    })
            },

            requestCentreSync: function () {
                this.isLoading = true;

                Sync.requestManualCentreSync(this.centre, this.syncType)
                    .then((res) => {
                        this.refreshStatus();
                        alert("A " + this.syncType + " sync has been requested for the centre. Please wait a couple of minutes and check again.");

                    })
                    .catch((res) => {
                        console.error("Failed to request manual centre sync: ", this.centre, this.syncType, res);
                        this.isLoading = false;

                        alert("Failed to request a manual sync for this centre!");

                    })
            },

            requestCompanySync: function () {
                this.isLoading = true;

                Sync.requestManualCompanySync(this.centre, this.company, this.syncType)
                    .then((res) => {
                        this.refreshStatus();
                        alert("A " + this.syncType + " sync has been requested for the company. Please wait a couple of minutes and check again.");
                    })
                    .catch((res) => {
                        console.error("Failed to request manual company sync: ", this.centre, this.syncType, res);
                        this.isLoading = false;

                        alert("Failed to request a manual sync for this company!");

                    })
            },

            onButtonClick: function() {

                if(this.isLoading || this.isSyncOngoing) {
                    return;
                }

                if(this.syncScope === 'company') {
                    this.requestCompanySync();
                    return;
                }

                this.requestCentreSync();

            }
        }

    }
</script>
